import { render, staticRenderFns } from "./adoptSchool.vue?vue&type=template&id=ecc53836"
import script from "./adoptSchool.vue?vue&type=script&lang=js"
export * from "./adoptSchool.vue?vue&type=script&lang=js"
import style0 from "./adoptSchool.vue?vue&type=style&index=0&id=ecc53836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports